
import { Component, Vue } from "vue-property-decorator";
import Menu from "@/components/Menu.vue";
import Flag from "@/components/common/Flag.vue";

@Component({
  components: { Flag, Menu },
})
export default class Header extends Vue {}
